import { formatUrlAsPageName } from '@analytics/utils';
import { inject, Injectable } from '@angular/core';
import { NotFoundRouteName } from '@core/models';
import { getRouteName } from '@core/jss-routing';
import { select, Store } from '@ngrx/store';
import { lastValueFrom, merge } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';
import { PageTrackEnhancer, type PageInfo } from '@analytics/models';

@Injectable()
export class NotFoundAnalyticsEnhancer extends PageTrackEnhancer {
  readonly #store$ = inject(Store);
  private readonly nameSelector$ = this.#store$.pipe(select(getRouteName));

  enhance(event: PageInfo) {
    const notFound$ = this.nameSelector$.pipe(
      filter((routeName) => routeName === NotFoundRouteName),
      map(() => {
        // Temporary patch to resolve 404 tracking in adobe analytics, see [WTA-4](https://jira.essent.nl/jira/browse/WTA-4).
        // To be fixed downstream.
        // splits the pageName (e.g. `www:essent:category:page`).
        // take the protocol and sitename and appends '404'.
        const parts = formatUrlAsPageName(event.url).split(':');
        const name = `${parts[0]}:${parts[1]}:404`;
        return {
          category: NotFoundRouteName,
          name,
        };
      })
    );

    const other$ = this.nameSelector$.pipe(
      filter((routeName) => routeName !== NotFoundRouteName),
      map(() => ({}))
    );

    return lastValueFrom(merge(notFound$, other$).pipe(first()));
  }
}
